const state = {
  searchReIssueCondition: {},
  reissueData: null
};
const getters = {
  searchReIssueCondition: state => state.searchReIssueCondition,
  reissueData: state => state.reissueData
};

const mutations = {
  changeSearchReIssueInfo(state, searchReIssue) {
    if (!searchReIssue) {
      return;
    }

    if (searchReIssue.searchReIssueCondition) {
      state.searchReIssueCondition = searchReIssue.searchReIssueCondition;
    }
    if (searchReIssue.reissueData) {
      state.reissueData = searchReIssue.reissueData;
    }
  },
  clearSearchReIssue(state, deleteSearchConditionFlg) {
    if (deleteSearchConditionFlg) {
      state.searchReIssueCondition = {};
    }
    state.reissueData = null;
  }
};

export default {
  state,
  getters,
  mutations
};
